<script setup lang="ts">
import { faHeadset } from '@fortawesome/pro-regular-svg-icons';
import Regex from '@static/regex';

const mobile = ref('');
const analyticsStore = useAnalyticsStore();
const authStore = useAuthStore();
const { userInfo } = classToRefs(authStore);

watch(
    userInfo,
    value => {
        if (value && !mobile.value) {
            mobile.value = value.mobile || '';
        }
    },
    { immediate: true }
);

function submit() {
    if (!Regex.mobile.full.test(mobile.value)) {
        swal({
            title: 'توجه',
            text: 'شماره موبایل خود را به صورت صحیح وارد کنید.',
            timer: 3000,
            confirmButtonText: 'باشه',
        });
        return;
    }
    analyticsStore.setWebengageUserInfo({
        mobile: mobile.value,
    });
    analyticsStore.trackAll('search-result-support-request');
    swal({
        text: 'درخواست پشتیبانی با موفقیت ارسال شد.',
        timer: 5000,
        confirmButtonText: 'متوجه شدم',
    });
}
</script>

<template>
    <div class="no-result-input-root">
        <div class="title-row">
            <div class="icon-wrapper">
                <mr-icon :icon="faHeadset" size="large" color="white" />
            </div>
            <div class="descriptions">
                <mr-typography
                    size="large"
                    weight="700"
                    color="var(--blue-700)"
                >
                    پرواز پیدا نکردی؟
                </mr-typography>
                <mr-typography weight="500" color="var(--blue-700)">
                    شماره‌ات رو وارد کن تا پشتیبانی مِستربلیط بررسی کنه.
                </mr-typography>
            </div>
        </div>
        <div class="input-row">
            <mr-input placeholder="شماره موبایل" hide-description required />
            <mr-button class="button-send" @click="submit">
                ارسال شماره
            </mr-button>
        </div>
    </div>
</template>

<style scoped lang="scss">
.no-result-input-root {
    max-width: 500px;
    width: 100%;
    background-color: white;
    padding: 12px;
    border-radius: 12px;
    gap: 12px;
    display: flex;
    flex-direction: column;
    @include shadow();
    .title-row {
        display: flex;
        gap: 16px;
        .icon-wrapper {
            background-color: usePalette();
            border-radius: 10px;
            padding: 8px;
            width: 60px;
            height: 60px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .descriptions {
            display: flex;
            flex-direction: column;
            gap: 4px;
        }
    }
    .input-row {
        display: flex;
        gap: 8px;
        .button-send {
            white-space: nowrap;
            padding: 0 16px;
        }
    }
}
</style>
